<div class="category-wrapper">
  <div class="category" [ngClass]="AlertType[type!]">
    {{ type | alertsType }}
  </div>
</div>
